import { useCallback } from 'react';
import UILink from 'UIComponents/link/UILink';
import HubSpotAppLink from '../common/components/HubSpotAppLink';
import { isIdle, isLoading, isRejected } from '../common/types/FetchStatus';
import { getRecordHref } from './internal/getRecordHref';
import { useObjectTypeSupportsRecord } from './internal/useObjectTypeSupportsRecord';
import { shouldLinkToAssociation } from './internal/useAssociatedObjectsRecord';
import AssociatedRecordLink from './AssociatedRecordLink';
import { jsx as _jsx } from "react/jsx-runtime";
const RecordLink = ({
  children,
  className,
  external = false,
  hideIfNotSupported = false,
  includeEschref = false,
  LinkComponent = UILink,
  LinkComponentProps = {},
  objectId,
  objectTypeId,
  onTrackClick,
  skeletonWidth
}) => {
  const objectTypeSupportsRecordState = useObjectTypeSupportsRecord(objectTypeId);
  const handleClick = useCallback(() => {
    if (onTrackClick) {
      onTrackClick({
        objectId,
        objectTypeId
      });
    }
  }, [objectId, objectTypeId, onTrackClick]);
  const linkToAssociation = shouldLinkToAssociation(objectTypeId);
  if (linkToAssociation) {
    return /*#__PURE__*/_jsx(AssociatedRecordLink, {
      className: className,
      LinkComponent: UILink,
      LinkComponentProps: LinkComponentProps,
      objectId: objectId,
      objectTypeId: objectTypeId,
      onTrackClick: onTrackClick,
      skeletonWidth: skeletonWidth,
      children: children
    });
  }
  if (isIdle(objectTypeSupportsRecordState) || isLoading(objectTypeSupportsRecordState) || isRejected(objectTypeSupportsRecordState)) {
    return /*#__PURE__*/_jsx("strong", {
      children: children
    });
  }
  if (!objectTypeSupportsRecordState.data) {
    return hideIfNotSupported ? null : /*#__PURE__*/_jsx("strong", {
      children: children
    });
  }
  if (external) {
    return /*#__PURE__*/_jsx(LinkComponent
    // Keep UILinkComponentProps at the top so HubSpotAppLink props override matching ones
    , Object.assign({}, LinkComponentProps, {
      className: className,
      external: true,
      href: getRecordHref(objectTypeId, objectId),
      onClick: handleClick,
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(HubSpotAppLink, {
    className: className,
    LinkComponent: LinkComponent,
    linkType: "CRM_OBJECT_RECORD",
    linkTypeProps: {
      includeEschref,
      objectTypeId,
      objectId
    },
    onTrackClick: onTrackClick,
    LinkComponentProps: LinkComponentProps,
    children: children
  });
};
export default RecordLink;